import { useNode } from "@craftjs/core";
import * as React from "react";

import TopLevelFloatingOptions from "@/components/editor/block-outline/floating-options/top-level-floating-component";
import BackgroundSquiggle from "@/components/editor/shared/background-squiggle";
import {
  BlockBackgroundColorWrapper,
  BlockMaxWidthWrapper,
} from "@/components/editor/shared/block-wrapper";
import { PaddingWrapper } from "@/components/editor/themes/crosby/constants";

import {
  ContentWrapper,
  PositionedWrapper,
} from "./paragraph-picture-component-styles";

interface Props {
  children: React.ReactNode;
}
export default function ParagraphPicture(props: Props) {
  const {
    connectors: { connect },
    id: nodeId,
  } = useNode();

  return (
    <BlockBackgroundColorWrapper
      ref={connect}
      id={nodeId}
      data-testid="paragraph-picture"
    >
      <PaddingWrapper>
        <BlockMaxWidthWrapper>
          <PositionedWrapper>
            <BackgroundSquiggle />
            <ContentWrapper>{props.children}</ContentWrapper>
          </PositionedWrapper>
        </BlockMaxWidthWrapper>
      </PaddingWrapper>
    </BlockBackgroundColorWrapper>
  );
}

ParagraphPicture.craft = {
  isCanvas: true,
  custom: {
    displayName: "Paragraph & Picture",
  },
  related: {
    leftOutlineOptions: TopLevelFloatingOptions,
  },
};
